import css from './modal.module.less';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import c from 'classnames';
import React, { forwardRef } from 'react';

export interface ModalProps {
    blocking?: boolean;
    onClickBackground?: () => void;
    onClickClose?: () => void;
    children: React.ReactNode;
    className?: string;
    onClick?: (e: React.MouseEvent) => void;
    onPointerDown?: (e: React.PointerEvent) => void;
    'data-testid'?: string;
    divProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
    closeColor?: string;
    insetCloseButton?: boolean;
}

export const Modal = forwardRef<HTMLDivElement, ModalProps>(function Modal(
    {
        blocking,
        onClickBackground,
        onClickClose,
        children,
        className,
        onClick = (e) => e.stopPropagation(),
        onPointerDown,
        'data-testid': testId,
        divProps,
        closeColor,
        insetCloseButton,
    },
    ref,
) {
    return (
        <div
            {...divProps}
            ref={ref}
            data-testid={testId}
            className={c(css.modal, { [css.blocking]: blocking })}
            onClick={onClickBackground}
        >
            <div className={c(css.content, className)} onClick={onClick} onPointerDown={onPointerDown}>
                {children}
                {onClickClose && (
                    <FontAwesomeIcon
                        color={`${closeColor || 'black'}`}
                        data-testid="modalCloseButton"
                        className={c(css.close, { [css.insetCloseButton]: insetCloseButton })}
                        icon={faTimes}
                        onClick={onClickClose}
                    />
                )}
            </div>
        </div>
    );
});
